package com.parmartechnologies.commerce.feature.cart.network

import com.parmartechnologies.core.network.rest.AppNetwork
import com.parmartechnologies.core.feature.cart.event.CartEvent
import com.parmartechnologies.core.feature.cart.network.CreateCustomerInvoiceRequest
import com.parmartechnologies.core.feature.cart.network.CreateCustomerInvoiceResponse
import com.parmartechnologies.core.feature.customer.event.CustomerEvent
import com.parmartechnologies.core.feature.customer.network.FetchCustomerRequest
import com.parmartechnologies.core.feature.customer.network.FetchCustomerResponse
import com.parmartechnologies.core.feature.customer.network.FindCustomerRequest
import com.parmartechnologies.core.feature.customer.network.FindCustomerResponse
import com.parmartechnologies.core.feature.customer.network.UpdateCustomerRequest
import com.parmartechnologies.core.feature.customer.network.UpdateCustomerResponse
import com.parmartechnologies.core.feature.invoice.event.InvoiceEvent
import io.ktor.client.request.post
import io.ktor.client.request.setBody
import io.ktor.client.statement.bodyAsText
import io.ktor.http.ContentType
import io.ktor.http.contentType
import com.parmartechnologies.core.network.rest.FriendlyClient
import com.parmartechnologies.core.constant.AppServer

class CartNetwork : AppNetwork(){


    suspend fun findInvoice(
        request: FindCustomerRequest,
        onResult: (FindCustomerResponse?) -> Unit
    ) {
        val apiRoute = AppServer.shared().getRestApiEndPointFor(CustomerEvent.api,CustomerEvent.FIND_BY_MOBILE)
        try {
            val response = FriendlyClient.post(apiRoute) {
                contentType(ContentType.Application.Json)
                setBody(request)
            }
            onResult(decoder.decodeFromString(response.bodyAsText()))
        } catch (t: Throwable) {
            onResult(null)
        }
    }

    suspend fun createCustomerInvoice(
        request: CreateCustomerInvoiceRequest,
        onResult: (CreateCustomerInvoiceResponse?) -> Unit
    ) {
        val apiRoute = AppServer.shared().getRestApiEndPointFor(InvoiceEvent.api,CartEvent.GENERATE_CUSTOMER_INVOICE.value)
        try {
            val response = FriendlyClient.post(apiRoute) {
                contentType(ContentType.Application.Json)
                setBody(request)
            }
            val responseJson = response.bodyAsText()
            print("Invoice Response")
            print(responseJson)
            onResult(decoder.decodeFromString(response.bodyAsText()))
        } catch (t: Throwable) {
            print(t.message)
            onResult(null)
        }
    }

    suspend fun updateCustomer(
        request: UpdateCustomerRequest,
        onResult: (UpdateCustomerResponse?) -> Unit
    ) {
        val apiRoute = AppServer.shared().getRestApiEndPointFor(CustomerEvent.api,CustomerEvent.UPDATE)
        try {
            val response = FriendlyClient.post(apiRoute) {
                contentType(ContentType.Application.Json)
                setBody(request)
            }
            onResult(decoder.decodeFromString(response.bodyAsText()))
        } catch (t: Throwable) {
            onResult(null)
        }
    }

    suspend fun retrieveCustomer(
        request: FetchCustomerRequest,
        onResult: (FetchCustomerResponse?) -> Unit
    ) {
        val apiRoute = AppServer.shared().getRestApiEndPointFor(CustomerEvent.api,CustomerEvent.RETRIEVE)
        try {
            val response = FriendlyClient.post(apiRoute) {
                contentType(ContentType.Application.Json)
                setBody(request)
            }
            onResult(decoder.decodeFromString(response.bodyAsText()))
        } catch (t: Throwable) {
            print(t)
            onResult(null)
        }
    }
}